module.exports = __webpack_public_path__ + "media/components/assets/dabang_bottle_05-a08a2e7bda6d8b3fdf9d0843bdb29fdc.png";